;(function() {
  'use strict'

  config.$inject = ["$sceDelegateProvider", "$locationProvider", "appProvider", "glErrorProvider"];
  tempResources.$inject = ["resourcesProvider"];
  stateAuth.$inject = ["$transitions", "$rootScope", "$state", "$timeout", "$location", "app", "AUTH_EVENTS", "userService"];
  states.$inject = ["$stateProvider", "$urlServiceProvider", "$uiViewScrollProvider"];
  var dependencies = [
    'ui.router',

    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ngMessages',

    'glow.lib',
    'glow.components',

    'app.core',

    'app.404',
    'app.action',
    'app.error',
    'app.home',
    'app.communities',
    'app.crowd',
    'app.channel',
    'app.element',
    'app.elementCollector',
    'app.public',
    'app.linkNotFound',
    'app.intent',
    'app.messageDetail',
    'app.messageList',
    'app.messageSendDialog',
    'app.messageCloseDialog',
    'app.messageClosedDialog',
    'app.page',
    'app.beacon',
    'app.passwordReset',
    'app.portal',
    'app.profile',
    'app.rewards',
    'app.search',
    'app.signup',
    'app.survey',
    'app.surveys',
    'app.thefeed',
    'app.verifyPromotion',
    'app.zone',

    'templates',

    'ng-fastclick',
    'monospaced.elastic',
  ]

  angular
    .module('app', dependencies)
    .config(config)
    .config(states)
    .config(tempResources)
    .run(stateAuth)

  // --------------------

  /* @ngInject */
  function config(
    $sceDelegateProvider,
    $locationProvider,
    appProvider,
    glErrorProvider
  ) {
    appProvider.setAppName('Glow')
    appProvider.setDefaultTags({
      title: 'Make your opinion count with Glow',
      type: 'website',
      siteName: 'Glow Feedback',
      // url: 'http://portal.glowfeed.com',
      description:
        'Gather insights from opinions to support better decision making with Glow.',
      image: 'http://static.glowfeed.com/img/glow-social-img-xsml.png',
    })

    glErrorProvider.setRoutes({
      DEFAULT: 'app.error',
    })

    // Used
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      new RegExp('.*.glowfeed.com.*template.html'),
    ])

    $locationProvider.html5Mode(true)
  }

  /* @ngInject */
  function tempResources(resourcesProvider) {
    resourcesProvider.create('notifications', {
      url: '/notification-lists/:id',
      params: {
        id: '@id',
      },
      actions: {
        list: {
          method: 'GET',
        },
        update: {
          method: 'PUT',
        },
      },
    })
  }

  /* @ngInject */
  function stateAuth(
    $transitions,
    $rootScope,
    $state,
    $timeout,
    $location,
    app,
    AUTH_EVENTS,
    userService
  ) {
    $rootScope.app = app

    /*
    // Commenting below codes because user won't be able to login or signup anymore
    // these authentication check is obsolete

    // load user data
    var loadUser = $transitions.onStart(null, function(trans) {
      var toState = trans.to()
      var toParams = trans.params()
      if (userService.hasCredentials()) {
        trans.abort()
        userService.login().finally(continueToState)
      }

      function continueToState() {
        // Hack to support floppyParams (see survey dimensions)
        // This is because floppyParams are unknown (eg crd[unknown_var]) so we cant
        // add them to the state param definitions
        if (toState.name === 'app.survey') {
          var url = $location.url()
          $state.go(toState.name, toParams, { location: 'replace' })
          $timeout(function() {
            $location.url(url)
          })
        } else {
          $state.go(toState.name, toParams)
        }
      }

      // unbind so only runs once
      loadUser()
    })

    // check authorisation
    $transitions.onStart(null, function(trans) {
      var toState = trans.to()
      if (
        toState.data &&
        toState.data.authenticate &&
        !userService.loggedIn()
      ) {
        trans.abort()
        $rootScope.$broadcast(AUTH_EVENTS.notAuthorised)
        $state.go('app.public')
      }
    })
    */

    $transitions.onStart(null, function(trans) {
      var toState = trans.to()
      if (toState.hide) {
        trans.abort()
        $state.go('app.404', null, { location: false })
      }
    })
  }

  /* @ngInject */
  function states($stateProvider, $urlServiceProvider, $uiViewScrollProvider) {
    $urlServiceProvider.config.strictMode(false)
    $urlServiceProvider.rules.otherwise('/')
    $uiViewScrollProvider.useAnchorScroll()

    $stateProvider.state('app', {
      abstract: true,
      templateUrl: 'app.template.html',
      controller: 'App',
    })
  }
})()
